export default {
  SET_DATA (state, data) {
    state.news = data
  },
  SET_POPULAR (state, limit) {
    state.popularNews = state.news.slice().splice(0, limit)
  }
}